<template>
  <div class="page-card lock-page">
    <div class="lock-box">
      <div class="lock-title">锁定屏幕</div>
      <div class="lock-user">{{ adminName }}</div>
      <div class="lock-tip">请输入锁屏密码后，系统将进入全屏遮罩锁定状态。</div>
      <el-input
        v-model="password"
        type="password"
        show-password
        placeholder="请输入锁屏密码"
        style="width: 320px; margin: 0 auto 18px"
      />
      <el-button type="primary" @click="lockNow">立即锁定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LockScreenPage',
  data() {
    return {
      password: ''
    }
  },
  computed: {
    adminName() {
      return this.$store.getters.adminName
    }
  },
  methods: {
    lockNow() {
      if (!this.password) {
        this.$message.warning('请输入锁屏密码')
        return
      }
      this.$store.dispatch('lockScreen', this.password)
      this.password = ''
      this.$message.success('已锁定屏幕')
    }
  }
}
</script>

<style scoped>
.lock-page {
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lock-box {
  text-align: center;
}

.lock-title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}

.lock-user {
  margin-top: 18px;
  font-size: 18px;
  color: #606266;
}

.lock-tip {
  margin: 14px 0 24px;
  color: #909399;
}
</style>
